import { customerBaseApi } from "@/react/services/api";

const ACCESS_GROUPING_URL = "access-grouping";

export const accessGroupingBaseAPI = customerBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccessGroupingData: builder.query({
      query: () => ({
        url: ACCESS_GROUPING_URL,
        method: "GET",
      }),
    }),
    updateAccessGroupingData: builder.mutation({
      query: (groupingEnabled) => ({
        url: ACCESS_GROUPING_URL,
        method: "PUT",
        body: { groupingEnabled },
      }),
    }),
  }),
});

export const {
  useLazyGetAccessGroupingDataQuery,
  useUpdateAccessGroupingDataMutation,
} = accessGroupingBaseAPI;
